import React, { memo } from 'react';

export default memo(function Warning() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="68.000000pt"
      height="60.000000pt"
      viewBox="0 0 68.000000 60.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,60.000000) scale(0.100000,-0.100000)"
        fill="#0093B2"
        stroke="none"
      >
        <path d="M302 553 c-43 -62 -282 -483 -282 -497 0 -8 7 -22 16 -30 13 -14 55 -16 309 -16 254 0 296 2 309 16 20 20 20 27 -3 72 -40 79 -273 467 -284 474 -23 15 -46 8 -65 -19z m197 -248 c78 -134 140 -249 136 -255 -4 -6 -109 -10 -296 -10 -239 0 -289 2 -289 14 0 22 281 496 294 496 6 0 76 -110 155 -245z" />
        <path d="M330 301 c0 -84 3 -101 15 -101 13 0 15 15 13 97 -2 66 -7 98 -15 101 -10 3 -13 -21 -13 -97z" />
        <path d="M325 140 c-4 -7 -3 -16 3 -22 14 -14 45 -2 40 15 -6 16 -34 21 -43 7z" />
      </g>
    </svg>
  );
});
